import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-chained-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from '../locales/en/translation.json';
import trTranslation from '../locales/tr/translation.json';
import frTranslation from '../locales/fr/translation.json';
import esTranslation from '../locales/es/translation.json';
import ruTranslation from '../locales/ru/translation.json';
import deTranslation from '../locales/de/translation.json';

const LOCALE_PATH = '/api/v1/getLocales--/{{lng}}';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: (code) => {
            if (code === 'en-US') return ['en'];
            if (code === 'fr-FR') return ['fr'];
            if (code === 'ru-RU') return ['ru'];
            if (code === 'es-ES') return ['es'];
            if (code === 'de-DE') return ['de'];
            if (code === 'tr-TR') return ['tr'];
            if (code === 'tr' || code === 'en' || code === 'fr' || code === 'ru' || code === 'es' || code === 'de')
                return [code];
            return ['en'];
        },
        load: 'languageOnly',
        whitelist: ['tr', 'en', 'fr', 'ru', 'es', 'de'],
        initImmediate: true,
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {translation: enTranslation},
            tr: {translation: trTranslation},
            fr: {translation: frTranslation},
            es: {translation: esTranslation},
            ru: {translation: ruTranslation},
            de: {translation: deTranslation}
        }
    }, (err, t) => {
        if (err) return console.error(err);
        i18n.reloadResources(["tr", "en", "fr", "ru", "es", "de"]);
    });

const getLanguageType = (lang) => {
    if (lang === 'tr') return trTranslation;
    if (lang === 'es') return esTranslation;
    if (lang === 'ru') return ruTranslation;
    if (lang === 'fr') return frTranslation;
    if (lang === 'de') return deTranslation;
    return enTranslation;
}

export default i18n;
